export interface PickablePerson {
  id: number;
  displayName: string;
  orgName: string | null;
}

/**
 * 下拉里显示的人名。
 *
 * 带上部门是因为系统里有同名的人（109 个账号里就有），
 * 只写名字的话选人时无从分辨，绑错了通知就发给另一个人。
 */
export function personLabel(person: PickablePerson): string {
  return person.orgName ? `${person.displayName}（${person.orgName}）` : person.displayName;
}
